export default {
  microbiologicalTestList: [],
  error: "",
  pagination: "",
  count: 0,
  microbiologicalTestSelected : null
};
